import { c as _c } from "react/compiler-runtime";
import type { LpCardListItem } from '@cc-shopping/contracts/credit-cards-page/landing-page/CreditCardsLPCardList';
import { Details } from '@cc-shopping/ui/primitives/Details';
import { theme } from '@cc-shopping/ui/theme';
import { Box, Typography } from '@mui/material';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
const MD_DOWN_MEDIA = theme.breakpoints.down('sm').replace(/^@media\s*/, '');
export function Accordion(t0) {
  const $ = _c(24);
  const {
    item
  } = t0;
  const {
    children,
    imageAltText,
    imageUrl,
    mobileImageUrl,
    title
  } = item;
  const desktopImageUrl = imageUrl || mobileImageUrl;
  const hasResponsiveMobileSource = imageUrl && mobileImageUrl;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== desktopImageUrl || $[2] !== hasResponsiveMobileSource || $[3] !== imageAltText || $[4] !== mobileImageUrl || $[5] !== title) {
    t2 = desktopImageUrl && <Box component="picture" sx={{
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
      "& img": {
        height: {
          xs: hasResponsiveMobileSource ? 40 : 24,
          md: 32
        },
        width: "auto",
        pb: "7px"
      }
    }}>{hasResponsiveMobileSource && <Box component="source" media={MD_DOWN_MEDIA} srcSet={mobileImageUrl} />}<Box component="img" src={desktopImageUrl} alt={imageAltText || title} /></Box>;
    $[1] = desktopImageUrl;
    $[2] = hasResponsiveMobileSource;
    $[3] = imageAltText;
    $[4] = mobileImageUrl;
    $[5] = title;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      flex: 1,
      fontSize: "18px"
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== title) {
    t4 = <Typography component="span" variant="textBold" sx={t3}>{title}</Typography>;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span aria-hidden="true" className="expand-icon mask-icon mask-icon-expand-more" style={{
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      outline: "1px solid #D8D9DA"
    }} />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t4) {
    t6 = <Box component="h3" sx={t1} gap="1.5rem">{t2}{t4}{t5}</Box>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      sx: {
        padding: "0.75rem"
      }
    };
    t8 = {
      sx: {
        backgroundColor: "white",
        border: "1px solid",
        borderColor: "neutral.lightest",
        borderRadius: "8px",
        boxShadow: "0 4px 8px 0 rgba(112, 144, 176, 0.10)"
      }
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      padding: "1.5rem",
      paddingTop: "0.75rem"
    };
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== children) {
    t10 = children.map(_temp);
    $[17] = children;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <Box sx={t9}>{t10}</Box>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t6) {
    t12 = <Box component="li"><Details variant="simple" SummaryComponent={t6} summaryComponentProps={t7} detailsProps={t8}>{t11}</Details></Box>;
    $[21] = t11;
    $[22] = t6;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}
function _temp(node, index) {
  return <StructuredContentRenderer key={`perk-body-${index}`} doc={node} />;
}